import { graphql } from '@predium/client-graphql';

graphql(`
  fragment CRREMDefaultConfiguration on CRREMDefaultConfigurationObject {
    __typename
    emissionFactorType
    setFor {
      org
      portfolios {
        id
      }
    }
  }
`);

graphql(`
  fragment CRREMCustomConfiguration on CRREMCustomConfigurationObject {
    __typename
    id
    title
    setFor {
      org
      portfolios {
        id
      }
    }
  }
`);

graphql(`
  fragment AsyncJob on async_job {
    description
    title
    entity_id
    status_id
    user_id
    org_id
  }
`);

graphql(`
  fragment AccessRightsPortfolio on portfolio {
    created_at
    id
    name
  }
`);

graphql(`
  fragment AccessRightsBuilding on building {
    address {
      city
      country_id
      postal_code
      street
    }
    areas(where: { area_type_id: { _eq: EBF } }) {
      __typename
      value
      type_of_use_id
      area_type_id
    }
    created_at
    id
    is_new_construction
    is_missing_energy_data
    economic_unit {
      portfolio {
        name
        id
      }
    }
  }
`);

export const GET_ALL_PORTFOLIOS_AND_BUILDINGS = graphql(`
  query GetAllPortfoliosAndBuildings {
    portfolio {
      ...AccessRightsPortfolio
    }
    building {
      ...AccessRightsBuilding
    }
  }
`);

export const GET_ORG_PREFERENCES = graphql(`
  query GetOrgPreferences {
    getOrgPreferences {
      co2PriceCurveConfig {
        kind
        growthStartValue
        growthAnnualPercent
        anchors {
          year
          pricePerTon
        }
      }
      co2PriceDefaultCurve
      isEconomicUnitsInFileDriveToggled
      isAutomaticActionCostUpdateToggled
      isSSOEnabled
      isSSOAutoCreateUser
      crremConfigurations {
        ... on CRREMDefaultConfigurationObject {
          ...CRREMDefaultConfiguration
        }
        ... on CRREMCustomConfigurationObject {
          ...CRREMCustomConfiguration
        }
      }
      availableReportingYears
      euTaxonomyDatasource
      activeEmissionFactorPreferences {
        ... on CrremOrgPreferences {
          __typename
          emissionFactorType
          crremVersion
          activeCRREMConfiguration {
            ... on CRREMDefaultConfigurationObject {
              ...CRREMDefaultConfiguration
            }
            ... on CRREMCustomConfigurationObject {
              ...CRREMCustomConfiguration
            }
          }
        }
        ... on NationalEnergyLawOrgPreferences {
          __typename
          emissionFactorType
        }
      }
    }
  }
`);

export const ASYNC_JOB_SUBSCRIPTION_ORG = graphql(`
  subscription AsyncJobSubscriptionOrg($title: String!, $orgId: Int) {
    async_job(where: { org_id: { _eq: $orgId }, title: { _eq: $title } }, order_by: { created_at: desc }, limit: 1) {
      ...AsyncJob
    }
  }
`);

export const ASYNC_JOB_SUBSCRIPTION = graphql(`
  subscription AsyncJobSubscription($title: String!, $entityId: Int) {
    async_job(
      where: { entity_id: { _eq: $entityId }, title: { _eq: $title } }
      order_by: { created_at: desc }
      limit: 1
    ) {
      ...AsyncJob
    }
  }
`);

export const GET_SEARCH_BUILDINGS = graphql(`
  query GetSearchBuildings(
    $search_string: String
    $portfolio_ids: [Int!] = null
    $limit: Int!
    $offset: Int!
    $orderBy: BuildingOrderByInput
  ) {
    searchBuildings(
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      portfolio_ids: $portfolio_ids
      search_string: $search_string
    ) {
      buildings {
        id
        street
        city
        postal_code
        is_new_construction
        has_energy_data
      }
      count
    }
  }
`);
